import styles from "./styles.scss";
import { FC } from "react";
import clsx from "clsx";
import {
  CircleSkeletonProps,
  MultilineTextSkeletonProps,
  RectangleSkeletonProps,
  RectangleSkeletonVariant,
} from "./types";

export const RectangleSkeleton: FC<RectangleSkeletonProps> = ({
  width = "100%",
  height = "100%",
  gap,
  borderRadius,
  className,
  variant = RectangleSkeletonVariant.Default,
}) => (
  <div
    className={clsx(styles.skeletonBackground, styles[variant], className)}
    style={{ width, height, borderRadius, marginBottom: gap }}
  />
);

export const CircleSkeleton: FC<CircleSkeletonProps> = ({
  diameter = "100%",
  marginBottom,
  className,
}) => (
  <div
    style={{
      width: diameter,
      height: diameter,
      minHeight: diameter,
      minWidth: diameter,
      marginBottom,
    }}
    className={clsx(
      styles.skeletonBackground,
      styles.circleSkeleton,
      className,
    )}
  />
);

const MINIMUM_NUMBER_OF_LINES = 2;

export const MultilineTextSkeleton: FC<MultilineTextSkeletonProps> = ({
  width = "100%",
  height = "100%",
  lines = MINIMUM_NUMBER_OF_LINES,
  className,
}) => (
  <div
    style={{ width, height }}
    className={clsx(styles.multilineSkeletonContainer, className)}
  >
    {new Array(
      lines < MINIMUM_NUMBER_OF_LINES ? MINIMUM_NUMBER_OF_LINES : lines,
    )
      .fill(null)
      .map((_, index) => (
        <div
          key={index}
          className={clsx(styles.skeletonBackground, styles.line)}
        />
      ))}
  </div>
);
